<template>
  <div class="selectSort">
    <ul>
      <li class="m_clearLR addTimeClick" @click="selectSort($event,2)" :class="currentIndex==2?'active':''">
        <div class="sort_boxL  m_floatL">
          <img src="@/../public/images/great.png" style="display:none" alt="" :class="sortIndex-2==3?'':'rotate180'" >
          <div class="m_floatR zhen_20">{{_lang[$route.query.type].zhen_20}}</div>
        </div>
        <div class="sort_boxR  m_floatR">
          <img :src="sortIndex-2==3?require('@/../public/images/s.png'):require('@/../public/images/j.png')" alt="" >
        </div>
      </li>
      <li class="m_clearLR " @click="selectSort($event,0)" :class="currentIndex==0?'active':''">
        <div class="sort_boxL   m_floatL">
          <img src="@/../public/images/great.png"  style="display:none" :class="sortIndex-0==3?'rotate180':''" alt="" >
          <div class="m_floatR zhen_18">{{_lang[$route.query.type].zhen_18}}</div>
        </div>
        <div class="sort_boxR  m_floatR">
          <img :src="sortIndex-0==3?require('@/../public/images/j.png'):require('@/../public/images/s.png')" alt="" >
        </div>
      </li>
      <li class="m_clearLR" @click="selectSort($event,1)" :class="currentIndex==1?'active':''">
        <div class="sort_boxL  m_floatL">
          <img src="@/../public/images/great.png" alt="" style="display:none" :class="sortIndex-1==3?'rotate180':''" >
          <div class="m_floatR zhen_19">{{_lang[$route.query.type].zhen_19}}</div>
        </div>
        <div class="sort_boxR  m_floatR">
          <img :src="sortIndex-1==3?require('@/../public/images/j.png'):require('@/../public/images/s.png')" alt="" >
        </div>
      </li>
      
    </ul>
  </div>
</template>

<script>
import {lang} from '@/utils/i18n'
export default {
  data(){
    return{
      _lang:[],
      currentIndex:0,
      sortIndex:-2,
      sortArr:['3','5','2','4','6','1',]//（1、时间升序 2、时间降序 3、名称升序 4、名称降序 5、文件大小升序 6、文件大小降序）
    }
  },
  created(){
    this._lang = lang
    setTimeout(() => {
      // this.selectSort(document.querySelector('.addTimeClick'),'2')
      document.querySelector('.addTimeClick').click()
    }, 50);
    
      
  },
  methods:{
    selectSort(e,index){
      var sort = ''
      if(this.currentIndex==index&&e.currentTarget.querySelector('img').className.indexOf('rotate180')==-1&&index!=2){
        this.sortIndex = this.currentIndex+3
        sort = this.sortArr[this.sortIndex]
      }else if(this.currentIndex==index&&this.currentIndex==2&&e.currentTarget.querySelector('img').className.indexOf('rotate180')!=-1){
        this.sortIndex = this.currentIndex+3
        sort = this.sortArr[this.sortIndex]
      }else{
        this.sortIndex = -2
        this.currentIndex = index
        sort = this.sortArr[this.currentIndex]
      }
      this.$emit('selectSort',sort)
    }
  }
}
</script>
<style lang="scss" scoped>
.selectSort{
  width:100%;
  background-color: #fff;
  box-shadow: 0px 3px 3px #e5e5e5;
  li{ 
    width:calc(100% - 0.64rem);
    padding: 0px 0.32rem;
    border-top:1px solid #ebebeb;
  }
  .sort_boxL{
    position: relative;
    height:1.02rem;
    line-height: 1.02rem;
    img{
      position: absolute;
      display: none;
      top:0.38rem;
      width:0.25rem;
      vertical-align: middle;
    }
    div{
      margin-left:0.36rem;
      font-size:0.3rem;
    }
  }
  
  .sort_boxR{
    height:1.02rem;
    line-height: 1.02rem;
    img{
      display: none;
      width:0.38rem;
      vertical-align: middle;
    }
  }
  li.active{
    img{
      display: inline-block;
    }
    div{
      font-size:0.32rem;
    }
  }
}
</style>

